import { render, staticRenderFns } from "./soil-type-echarts.vue?vue&type=template&id=2cdf8f90&scoped=true&"
import script from "./soil-type-echarts.vue?vue&type=script&lang=js&"
export * from "./soil-type-echarts.vue?vue&type=script&lang=js&"
import style0 from "./soil-type-echarts.vue?vue&type=style&index=0&id=2cdf8f90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdf8f90",
  null
  
)

export default component.exports